import React from 'react';
import { withFederation, withClientOnlyBoundary } from '@unisporkal/federation';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { lazyComponent } from '@unisporkal/react-lazy-component';
import Providers from '../Providers';
import { APP_NAME, COMPONENTS } from '../constants';

const Component = lazyComponent(
  (props) => import(`./components/${props.siteName}/Footer`)
);

// Devtools has no server-rendered markup, so mounting it during SSR would
// hydrate against nothing; deferred to the client to keep the tree in sync.
const DevTools = withClientOnlyBoundary(ReactQueryDevtools, {
  appName: APP_NAME,
  componentName: 'ReactQueryDevtools',
  errorBoundary: true,
});

const Footer = ({ layout, locale, siteName }) => (
  <Providers
    siteName={siteName}
    locale={locale}
  >
    <Component
      layout={layout}
      siteName={siteName}
    />
    <DevTools
      initialIsOpen={false}
      buttonPosition="bottom-left"
    />
  </Providers>
);

export default withFederation(APP_NAME, COMPONENTS.FOOTER, Footer);
